import React from "react";
import { useTranslation } from "react-i18next";
import config from "../../config";
import { capitalize, formatFullname, getObjectWithJsonDataToFormValues, isObject } from "../../libraries/utils";
import Avatar from '../../components/commons/Avatar';
import Icon from "../../libraries/icons";


export default function AppointmentElement({ appointment, ...rest }) {
  const { t, i18n } = useTranslation();

  const { professional, status, date, time, location, sub_type, time_slot } = getObjectWithJsonDataToFormValues(
    appointment,
    ['id', 'time', 'time_slot', 'date', 'sub_type', 'status', 'professional', 'location']
  );
  
  const [ specialty1, specialty2 ] = professional.specialty.split("_/_/_")
  const specialtyString = (specialty1 ?? "") + " - " + (specialty2 ?? "")

  const types = (type) => {
    return config.APPOINTMENTS.filter((f) => f.type === type)[0] || {};
  }

  const day = new Date(date)
  const finish_time = time_slot ? time_slot.end_time : `${time[0]}${parseInt(time.split("")[1])+1}${time.substr(2)}`
  
  const icon = status === config.TRANSACTIONS.BOOK.STATUS.CANCELED
    ? "x" : (
      status === config.TRANSACTIONS.BOOK.STATUS.COMPLETED ? "checkmark" : types(appointment.sub_type).icon
    )
  
  return (
    <div key={rest.key}>
      <div className="flex">
        <div className="relative">
          <Icon className="w-5 h-5 bg-base-300 text-white rounded-full p-0.5 mx-auto mb-2 absolute -left-1 -top-1 z-10 border-2 border-white" name={icon} />
          <Avatar
            image={professional.profile_image}
            label={professional.username}
            className="rounded-full w-12 h-12"
            containerClassName="mr-3"
          />
        </div>
        <div className="flex flex-col flex-auto">
          <div className="flex justify-between leading-tight">
            <div className="mb-4">
              <h3 className="text-primary">{formatFullname(professional)}</h3>
              <small>{capitalize(specialtyString)}</small>
            </div>
            <small className="text-gray-500 mt-1">{t("timeRemains", { date: new Date(date) }).replace(config.TRANSLATE.TIME_REMAINS, '')}</small>
          </div>
          <div className="mt-2">
            {time && (
              <small className="truncate w-7/12 inline-block">
                <Icon className="h-4 w-4 mr-1 inline-block text-success" name="clock" />
                {day.toLocaleDateString()} {time}-{finish_time}
              </small>
            )}
            {![config.TRANSACTIONS.BOOK.SUB_TYPE.VIDEO, config.TRANSACTIONS.BOOK.SUB_TYPE.MESSAGE].includes(sub_type) && ( 
              <small className="truncate w-5/12 inline-block">
                <Icon className="h-4 w-4 mr-1 inline-block text-success" name="location_marker" />
                {isObject(location) ? location.name : location}
              </small>
            )}
          </div>
        </div>
      </div>
      
    </div>
  );
}
